export const store = {
  postsGrid: null,
  isAnchorScroll: false,
  activeTags: [],
  posts: [],
  loadMoreUrls: [],
  customHistory: []
};
